import { isRawRow } from "@/domain/view/components/datatable/datatable-types";
import { Workspace } from "@/domain/workspace/models/workspace-model";

import { Datatable } from "../../../view/components/datatable/datatable";
import { IndicatorListItem } from "../../models/indicator-model";

import { COLUMN_ID_INDICATOR_TITLE } from "./columns/indicator-title-column";
import { COLUMN_ID_INDICATOR_UNIT } from "./columns/indicator-unit-column";
import { useIndicatorDatatableColumns } from "./use-indicator-datatable-columns";

interface IndicatorDatatableProps {
  viewKey: string;
  workspace: Workspace;
  indicatorList: IndicatorListItem[];
}

export function IndicatorDatatable(props: IndicatorDatatableProps) {
  const indicatorDatatableColumns = useIndicatorDatatableColumns({
    workspace: props.workspace,
  });

  return (
    <div className="relative flex h-full grow items-stretch overflow-y-scroll" data-testid={"indicator-datatable"}>
      <Datatable<IndicatorListItem>
        viewKey={props.viewKey}
        workspaceId={props.workspace.id}
        data={props.indicatorList}
        columns={indicatorDatatableColumns.columnConfigurationList}
        debugTable={false}
        synchToApi={true}
        getColumnCanGlobalFilter={(column) => {
          return [COLUMN_ID_INDICATOR_TITLE, COLUMN_ID_INDICATOR_UNIT].includes(column.id);
        }}
        globalFilterFn={(row, columnId, value, _addMeta) => {
          if (!value || value.length === 0 || value === "") {
            return true;
          }

          // Skip non-raw rows (SectionData or DoubleSectionData)
          if (!isRawRow(row.original)) {
            return true;
          }

          if (columnId === COLUMN_ID_INDICATOR_TITLE) {
            return row.original.title.toLowerCase().includes(value.toLowerCase());
          }

          if (columnId === COLUMN_ID_INDICATOR_UNIT) {
            if (!row.original.unit) {
              return false;
            }

            return `${row.original.unit.title} (${row.original.unit.symbol})`
              .toLowerCase()
              .includes(value.toLowerCase());
          }
          // if we don't match any column we return false
          return false;
        }}
        config={{
          savedViewsMenu: false,
        }}
      />
    </div>
  );
}
